module.exports = __webpack_public_path__ + "static/media/logo_white.cc4e2784.png";